module.exports = __webpack_public_path__ + "static/media/Z61_8694.37409375.jpg";